<template>
  <div id="informationStation">
    <!-- 未連接至網路的提醒 -->
    <div v-if="!closeOffline && isOffline" class="v3offline">
        <i class="icon-exclamation-mark-circle"></i>
        <p>未連接至網路</p>
        <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
    </div>
		<!-- 隨頁面滑動會頂部鎖定的分類選單 -->
    <div class="mainContentTopMenu mainContentTopMenuFixed">
      <!-- 滑動式分類選單 -->
      <swiper ref="articleTypeSwiper" class="articleTypeSwiper" :options="articleTypeSwiperParams">
        <swiper-slide v-for="(tag,tag_ind) in articleType" :class="{selected: tag_ind === whichTypeIndexIsChoose}" :key="tag_ind">
          <span>
            <p @click="selectTypeByMenu(tag_ind)">
              {{tag.type_name}}
            </p>
          </span>
        </swiper-slide>
      </swiper>
      <!-- //! 網頁版莫名其妙的 bug , 初始時會有閃動現象, 為動畫起始現象 -->
      <!-- 神奇遮罩 點擊觸發機關產生 -->
      <div :class="hiddenMenuIsOpen ? 'show' : 'hide'" class="articleTypeSwiperMask">選擇分類</div>

      <!-- 隱藏式分類選單觸發機關 箭頭 -->
      <div class="articleTypeMenuButton" :class="{active: hiddenMenuIsOpen}" @click="articleTypeMenuButtonHandle"><i class="icon-arrow-down"></i></div>

      <!-- 隱藏式分類選單 -->
      <div :class="hiddenMenuIsOpen ? 'show' : 'hide'" class="articleTypeMenu">
          <div v-for="(tag,tag_ind) in articleType" @click="selectTypeByMenu(tag_ind)" :class="{selected: tag_ind === whichTypeIndexIsChoose}" :key="tag_ind">
            {{tag.type_name}}
          </div>
      </div>
      <div :class="hiddenMenuIsOpen ? 'show' : 'hide'" class="mask" @click="articleTypeMenuButtonHandle"></div>
    </div>    
    
    <!-- 文章階層 -->
    <div id="Pages" class="swiper-container swiperPages">
      <swiper ref="articleSwiper" class="articleSwiper" :options="articleSwiperParams">
        <swiper-slide v-for="(tag,tag_ind) in articleType" :key="tag_ind" :news_type="tag.type_id">
          <transition name="fade">
          <!-- 滑動載入包裝 -->
          <mescroll-vue ref="mescroll" :down="getMescrollDown(tag_ind)" :up="getMescrollUp(tag_ind)" @init="mescrollInit(tag_ind, arguments)">
          <div class="articleList">
            <ul v-if="article[tag_ind]">
              <template v-for="(news,news_ind) in article[tag_ind].list" >
                <li :key="news_ind">
                  <router-link :to="{name: 'v3newsDetail', params: {id: news.news_id}}">
                  <span class="articleTag">{{news.news_type}}</span>
                  <div class="articleContent">
                      <div class="articleContentImg" v-if="news.title_img !== ''" v-lazy:background-image="news.title_img" ></div> 
                      <div class="articleContentImg" v-if="news.title_img == ''"></div>
                      <span class="articleContentNote">{{news.title}}</span>
                      <span class="articleContentIcon"><i class="icon-right-roundedline"></i></span>
                  </div>
                  </router-link>
                </li>
                <li v-if="news_ind !== 0 && news_ind % 10 === 0" :key="`ad-${news_ind}`" style="padding:0">
                  <!-- 廣告部分 -->
                  <template>
                      <script2 type="text/javascript" async="true" src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" />
                      <ins
                          class="adsbygoogle"
                          style="display:block"
                          data-ad-format="fluid"
                          data-ad-layout-key="-h2+k-m-92+j4"
                          data-ad-client="ca-pub-9449560331897859"
                          data-ad-slot="9748661614"
                      />
                      <script2 type="text/javascript"> (adsbygoogle = window.adsbygoogle || []).push({}); </script2>
                  </template>
                </li>
              </template>                        
            </ul>
            <!-- BD 不要這個 -->
            <!-- <div class="articleListLoading" v-if="article[tag_ind].loading">
              <div></div>
              <p>加載最新文章中...</p>
            </div> -->
            <div class="articleListEmpty" v-if="!article[tag_ind].loading && article[tag_ind].list.length === 0">
              <i class="icon-empty-status"></i>
              <p>此類別目前尚無文章</p>
            </div>
          </div>          
          </mescroll-vue>
          </transition>
        </swiper-slide>
      </swiper>
    </div>

    <!-- v3 無圖案 Toast -->
    <div v-show="v3Toast.show" class="v3Toast">{{v3Toast.text}}</div>
  </div>  
  
</template>
<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import axios from 'axios'
axios.defaults.timeout = 1000 * 10

// CommunityUser 路人模式
// CommunityUserToken 會員模式

//Rdu76ObLEv7h2PvWheejAM9flRB/OPhENecgJgNR19JfUfNjmbVPdThudS1N7+pDXZrmKC+eIaqKWaBS7FxU2SqhzCvhxLw55+4KXvK8RCoZjn2ZLV05e8gbv9kmSNvvVGZ67+us/tldI2NqiJB46XUHANWLi1r6qqVp1RfEWZw=

const GetArticleList = (params) => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/ComitteeArticleList_Anonymous`,{
  params
}).then(data => [null, data]).catch(err => [err, null])

const GetArticleTypes = () => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/AllTypes`,{
}).then(data => [null, data]).catch(err => [err, null])

export default {
  name: '',
  data(){
    const self = this
    return {
      closeOffline: false,
      // 仿生網頁 - 主類別選單 ( 所有文章主分類 ) 與 下拉隱藏式選單
      articleType: [],
      articleTypeSwiper: null,
      articleTypeSwiperParams: {
        slidesPerView: 'auto',
        spaceBetween: 28, // 2020/11/17 09:53 調至 guildline 一模一樣
        slidesOffsetBefore: 30,
        slidesOffsetAfter: 30,
        freeMode: true,
        loop: false
      },
      hiddenMenuIsOpen: false,
      whichTypeIndexIsChoose: 0,
      menuShouldFixedOnTop: false,
      // 當前文章列表 ( 換頁以 filter 取代 )
      article: [],
      sliding: false,
      articleSwiper: null,
      articleSwiperParams:{
        direction: 'horizontal',
        loop: false,
        preloadImages: false,
        lazy: true,
        autoHeight: true,
        followFinger:false,
        on: {
          slideChangeTransitionStart: function() {
            self.selectType(this.activeIndex)
          },
          activeIndexChange: function () {
            self.sliding = true
          },
          transitionEnd: function() {
            self.sliding = false
          }
        }
      },
      v3Toast:{
        show: false,
        text: '',
        duration: 1000
      },
      toastTimer: null
    }
  },
  components: {
    MescrollVue
  },
  mounted() {
    let vm = this
    this.getArticleType()
    this.articleSwiper = vm.$refs.articleSwiper.swiper
    this.articleTypeSwiper = vm.$refs.articleTypeSwiper.swiper
  },
  watch: {
      '$route' (to, from) {
        let n = this.$refs.mescroll[this.whichTypeIndexIsChoose].mescroll.preScrollY
        this.$refs.mescroll[this.whichTypeIndexIsChoose].mescroll.scrollTo(n, 0)
        if(to.name === "v3news" && to.query){
            this.goType(to.query.news_type)
        }
      },
      isOffline: function(val) {
          // 在下次無網路時再度打開上面的 top tip
          if (!val) this.closeOffline = false
      }
  },
  methods:{
    // 顯示 v3Toast
    showV3Toast(text) {
        clearTimeout(this.toastTimer)
        this.v3Toast.text = text;
        this.v3Toast.show = true;
        this.toastTimer = setTimeout(() => {
            this.v3Toast.show = false;
        }, this.v3Toast.duration);
    },
    closeOfflineHandle() {
      this.closeOffline = true
    },
    goType(typeId) {
      let vm = this

      if (this.$route.query && this.$route.query.news_type && vm.articleType) {
          let p = vm.articleType.findIndex(e => e.type_id === +typeId)
          vm.selectTypeByMenu(p)
      }
    },
    // 上拉加載 (註冊)
    getMescrollUp (tabIndex) {
      const vm = this
      return {
        auto: false,
        callback: vm.loadMoreData,
        htmlLoading: '<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">載入更多</p>',
        htmlNodata: '<p class="upwarp-nodata">噢不！沒有更多了</p>',
        textInOffset: '載入更多',
        textOutOffset: '',
        textLoading: '載入中...',
      }
    },
    // 下拉更新 (註冊)
    getMescrollDown(tabIndex) {
      const vm = this
      return {
        auto: false,
        callback: vm.refreshAllData,
        textInOffset: '下拉更新',
        textOutOffset: '',
        textLoading: '載入中...'
      }
    },
    // 初始註冊 mescroll 的地方
    mescrollInit(tabIndex, arg) {
      this.articleType[tabIndex].mescroll = arg[0]
      this.articleType[tabIndex].mescroll.tabIndex = tabIndex
    },
    articleTypeMenuButtonHandle() {
      this.hiddenMenuIsOpen = !this.hiddenMenuIsOpen
    },
    // 滑到最底層載入更多文章方法
    loadMoreData() {
      this.getArticleData(this.whichTypeIndexIsChoose)
    },
    // 單一頁面更新機制 ( 清空文章 )
    refreshAllData(mescroll) {
      if (this.isOffline) {
        this.showV3Toast('網路狀態異常')
        this.articleType[mescroll.tabIndex].mescroll.endSuccess()
        return
      }
      this.article[mescroll.tabIndex].list = []
      this.selectType(mescroll.tabIndex)
      this.articleType[mescroll.tabIndex].mescroll.optUp.hasNext = true
      // 下拉重整清除所有負面狀態 ( "沒有更多", "空的", "加載中" )
      this.articleType[mescroll.tabIndex].mescroll.hideUpScroll(true)
    },
    async getArticleType () {
      // 取得所有文章分類種類 articleType
      let paramsObj = {
        Quantity: 10 // 共 13 篇, 3 篇永久置頂, 其他 10 篇沒繳錢擺下面
      }
      const [typeErr, typeRes] = await GetArticleTypes()
      const [listErr, listRes] = await GetArticleList(paramsObj)
      if (typeErr || listErr) {
        console.log("[GetArticleTypes ERROR]", typeErr)
        console.log("[GetArticleTypes ERROR]", listErr)
        return
      }

      if(typeRes && typeRes.data.Data.MainTypes.length > 0 ){
        // 文章列表初始化, 先給他個 10 篇姑且顯示
        this.article.push({id: 0, list: listRes.data.Data.Articles.map(HanderFormatFromAPI), total: listRes.data.Data.Total, loading: false})
        // 別忘了沒排序會變成 bug
        let resTypeArray = typeRes.data.Data.MainTypes.sort((a, b) => b.SortIdx - a.SortIdx).map(e => {
          this.article.push({id: e.MainTypeId, list: [], total: 0, loading: true})
          return {
            type_id: e.MainTypeId,
            type_name: e.MainTypeName,
            type_sub: e.SubTypes
          }
        })
        this.articleType = [{ type_id: 0, type_name: '全部'}].concat(resTypeArray.reverse())
        // BUG : 因選單激活樣式比較特別, swiper 不會幫預留空格, 因此需手動滑一點
        let p = false
        if (this.$route.query && this.$route.query.news_type) {
            p = this.articleType.findIndex(e => e.type_id === +this.$route.query.news_type)
        }
        setTimeout(() => {
          !p && this.$refs.articleTypeSwiper.swiper.slideTo(0)
          p && this.selectTypeByMenu(p)
        }, 10)        
      }
    },
    async getArticleData(mainTypeIndex, selectTypeTrigger = false, QuantityCorrection = undefined) {
      if (this.isOffline) {
        this.showV3Toast('網路狀態異常')
        this.articleType[mainTypeIndex].mescroll.endErr()
        return
      }
      // 先找暫存有幾個了
      let mainTypeId = this.articleType[mainTypeIndex].type_id
      if (this.article[mainTypeIndex] === undefined) this.article[mainTypeIndex] = {id:mainTypeId ,list: [], loading: true}
      let alreadyExist = this.article[mainTypeIndex].list.length 
      // 經由 selectType 觸發的就別再浪費 API 了
      if (selectTypeTrigger && alreadyExist > 0){
        this.article[mainTypeIndex].loading = false
        return
      } 
      // 數量補正支援 防止重複文章出現 也可以寫在參數那啦
      let Quantity = QuantityCorrection || 10
      // 決定參數
      let paramsObj = {
        MainTypeId: mainTypeId ? mainTypeId : undefined,
        Quantity,
        Skip: alreadyExist
      }
      this.article[mainTypeIndex].loading = true
      const [err, res] = await GetArticleList(paramsObj)
      if (err) {
        this.article[mainTypeIndex].loading = false
        this.articleType[mainTypeIndex].mescroll.endErr()
        console.warn('[GetArticleList ERROR]', err)
      }
      if (res) {
        this.article[mainTypeIndex].loading = false
        if (res.data.Data.Articles.length === 0) {
          this.articleType[mainTypeIndex].mescroll.endSuccess()

          if (alreadyExist === 0) {
            // 重頭到尾都沒有文章顯示的類別可憐蟲
            // 移除下拉加載
            this.articleType[mainTypeIndex].mescroll.hideUpScroll(true)
            this.articleType[mainTypeIndex].mescroll.optUp.hasNext = false
            return
          }
          this.articleType[mainTypeIndex].mescroll.showNoMore()
          // 移除下拉加載
          this.articleType[mainTypeIndex].mescroll.optUp.hasNext = false
          return 
        }
        // 前端統一標準化後端的輸出
        let resData = res.data.Data.Articles.map(HanderFormatFromAPI)
        // 特殊 BUG : 下拉載入更多 > 有個調皮蛋新增了一篇文章 > 下一次的載入更多 > 取得結果會有一篇重複
        // 解法 : 與前 Quantity 筆交叉比對有沒有重複的文章 id
        let inspectArray = this.article[mainTypeIndex].list.slice(this.article[mainTypeIndex].list.length - Quantity)
        resData.filter(e => inspectArray.findIndex(inspect => inspect.news_id === e.news_id) === -1)
        // 極少發生的特殊情況 BUG 分支 : 當取到所有資料都與之前重複, 會引發永遠拿不到文章的情況
        // 解法v.1 : 立即進行文章數量補正, 前 cannonFodder 筆就去當砲灰, 再往後取 10 筆, 理論上資料庫文章會比前端多
        if (resData.length === 0) {
          let cannonFodder = Math.max(Math.abs(res.data.Data.Total - this.article[mainTypeIndex].total), 10)
          getArticleData(mainTypeIndex, false, cannonFodder + 10)
        }
        // 將新資料加入原有陣列中舊資料後面
        this.article[mainTypeIndex].list = this.article[mainTypeIndex].list.concat(resData)
        this.article[mainTypeIndex].total = res.data.Data.Total
        this.articleType[mainTypeIndex].mescroll.endSuccess()
      }    
    },
    selectTypeByMenu(index) {
      this.$refs.articleSwiper.swiper.slideTo(index)
    },
    selectType(index) {
      // 包裝成統一控制器
      this.$router.replace({ path: '/v3news', query: { news_type: this.articleType[index].type_id }})
      this.whichTypeIndexIsChoose = index;
      this.$refs.articleTypeSwiper.swiper.slideTo(index - 1)
      this.$refs.articleSwiper.swiper.slideTo(index)
      this.getArticleData(index, true)
      this.hiddenMenuIsOpen = false
    }
  },
  beforeRouteLeave (to, from, next) {
    const vm = this
      if(vm.isOffline){
            vm.showV3Toast('網路狀態異常')
    }else{
        next()
    }
  }
}

function HanderFormatFromAPI(e) {
  return {
    news_id: e.Id,
    news_type: e.MainTypeName,
    news_typeId: e.MainTypeId,
    news_subType: e.SubTypeName,
    news_subTypeId: e.SubTypeId,
    title: e.Title,
    title_img: e.Title_img,
    abstract_note: e.AbstractNote
  }
}
</script>
<style lang="css">
.v3Toast {
    position: fixed;
    z-index: 99;
    left: 50%;
    top: 50%;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    background: rgba(0,0,0,.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    color: #fff;
    font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    font-weight: 500;
}
.v3offline {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 44px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 21px;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    background: rgba(66, 137, 167, .9); /* #4289a7 2020/11/19 13:37 BD mean this color */ 
    -webkit-transition: .5s;
    transition: .5s;
}
.v3offline > i {
    margin-right: 9px;
    font-size: 19px;
    width: 19px;
    height: 19px;
}
.v3offline div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 18px;
    width: 18px;
    height: 18px;
}
#informationStation {
    background-color: #fff;
    height: 100vh;
    display: flex;
    flex-direction: column;
}
#informationStation .articleTypeSwiperMask {
    position: absolute;
    z-index: 10;
    top: 0;
    padding: 9px 13px;
    line-height: 22px;
    color: #484848;
    font-size: 15px;
    font-weight: 400; /* 2020/11/17 10:03 更改為目前 guildline 形式 */
    width: calc(100% - 26px); /* minus padding */
    transition: .4s;
    transition-timing-function: ease-in-out;
    background: #fff;    
}

#informationStation .articleTypeSwiperMask.show {  
  opacity: 1;
}
#informationStation .articleTypeSwiperMask.hide {
  opacity: 0;
  pointer-events: none;  
}

#informationStation #Pages ul {
	  min-height: calc(100vh - 44px - 50px);
}
#informationStation .articleList {
	  position: relative;
}
#informationStation .articleList ul {
	  margin: 0px;
}
#informationStation .articleList ul > li {
    padding: 16px 22px 21px 12px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    width: 100%;
}
#informationStation .articleList ul > li > a {
    padding: 0;
}
#informationStation .articleList ul > li .articleTag {
    color: #46b39a;
    align-self: flex-start;
    margin-bottom: 12px;
    background-color: #efeff4;
    padding: 0px 8px 1px;
    font-weight: 400;
    font-size: 13px;
    border-radius: 13px;
    line-height: initial;
    display: inline-block;
}
#informationStation .articleList ul > li .articleContent {
	  display: flex;
}
#informationStation .articleList ul > li .articleContent .articleContentImg {
    height: 60px;
    width: 90px;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #e8e8e8;
    background-position: center center;
}
#informationStation .articleList ul > li .articleContent .articleContentNote {
    flex: 1;
    padding: 0 4px 0 12px;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    font-weight: bold; /* 2020/11/23 怎麼又要粗體了 */
    color: #484848;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
#informationStation .articleList ul > li .articleContent .articleContentIcon {
    font-size: 18px;
    line-height: 18px;
    align-self: center;
    color: #46b39a;
}
#informationStation .articleList .articleListEmpty, #informationStation .articleList .articleListLoading {
    position: absolute;
    top: 0;
    width: 100%;
    height: calc(100vh - 44px - 50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    color: #999;
}
#informationStation .articleList .articleListEmpty > i {
    font-size: 60px;
    margin-bottom: 20px;
}
#informationStation .articleList .articleListLoading > div {
    width: 100px;
    height: 100px;
    background-image: url("../../assets/loading-state-image.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
#informationStation .mainContentTopMenu {
    min-height: 40px;
    width: 100%;    
    z-index: 10;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, .15);
    background-color: white;
    color: #999;
    padding: 7px 0 6px 0;
    box-sizing: border-box;
    position: relative;
}
#informationStation .mainContentTopMenu .articleTypeSwiper {
    width: calc(100% - 40px);
    margin: 0;
}
#informationStation .mainContentTopMenu .articleTypeSwiper .swiper-slide {
    width: auto !important;
    font-size: 16px;
    font-weight: 400;
}
#informationStation .mainContentTopMenu .articleTypeSwiper .swiper-slide > span > p {
    line-height: 22px;
    padding: 3px 0 1px 0;
}
#informationStation .mainContentTopMenu .articleTypeSwiper .swiper-slide.selected > span {
    color: #fff;
    font-weight: bold;
}
#informationStation .mainContentTopMenu .articleTypeSwiper .swiper-slide.selected > span:after {
    content: 'A';
    font-size: 16px;
    color: transparent;
    position: absolute;
    line-height: 22px;
    top: 0px;
    left: -10px;
    width: 100%;
    height: auto;
    padding: 3px 10px 1px 10px;
    background: #4289a7;
    border-radius: 13px;
    z-index: -1;
}
#informationStation .mainContentTopMenu .articleTypeMenuButton {
    position: absolute;
    font-size: 24px;
    top: 50%;
    right: 6px;
    -webkit-transform: translate(-50%);
    transform: translate(0px, -50%);
    width: 40px;
    height: auto;
    background: #fff;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
}
#informationStation .mainContentTopMenu .articleTypeMenuButton.active {
    transform: translateY(-50%) rotate(180deg);
 } 
#informationStation .mainContentTopMenu .articleTypeMenu {
    position: absolute;
    max-height: 350px;
    overflow: auto;
    top: 40px;
    background-color: #fff;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    box-shadow: inset 0px 3px 6px rgba(0, 0, 0, .15);
    display: flex;
    flex-wrap: wrap;
    padding: 20px 14px 20px 9px; /* 2020/11/17 10:03 更改為目前 guildline 形式 */
    z-index: 9;
    transition: .4s;
    transition-timing-function: ease-in-out;
}
#informationStation .mainContentTopMenu .articleTypeMenu.show {
  animation: panel-fadeIn 0.4s ease-in-out;
  opacity: 1;
}
#informationStation .mainContentTopMenu .articleTypeMenu.hide {
  opacity: 0;
  pointer-events: none;
}
#informationStation .mainContentTopMenu .articleTypeMenu > div {
  min-width: 40px; /* 60 - 20 左右 padding */
  padding: 3px 10px 2px 10px; /* 2020/11/17 10:03 更改為目前 guildline 形式 */
  margin: 12px 4px; /* 2020/11/17 10:03 更改為目前 guildline 形式 */
  color: #999;
  font-weight: 400;
  border-radius: 13px;
  border: 1px solid #d2d2d2;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#informationStation .mainContentTopMenu .mask {
  height: calc(100vh - 40px);
  background: #04040f;
  z-index: -1;
  position: absolute;
  top: 40px;
  left: 0px;
  width: 100%;
  transition: .4s;
  transition-timing-function: ease-in-out;
}
#informationStation .mainContentTopMenu .mask.hide {
  opacity: 0;
  pointer-events: none;
}
#informationStation .mainContentTopMenu .mask.show {
  opacity: 0.4;
}
#informationStation .mainContentTopMenu .articleTypeMenu > div.selected {
    background-color: #4289a7;
    border: none;
    color: #fff;
}
#informationStation .mescroll {
    position: relative;
    overflow-x: hidden;
}
#informationStation .mainContentTopMenuFixed {
    margin-top: 0;
    max-width: 100%;
} 

@keyframes panel-fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.fade-enter-active{
  transition: opacity .3s;
} 

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/v3/news.vue